// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"parabola"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 12C3.9 12 4.8 10.9 6.6 8.5C7.35 7.5 8.85 3 12 3C15.15 3 16.65 7.5 17.4 8.5C19.2 10.9 20.1 12 21 12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 19H12M3 19V20M3 19V17M12 19H21M12 19V20M12 19V17M21 19V20M21 19V17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ParabolaIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'parabola',
    ref,
    icon: element,
  },
));

ParabolaIcon.displayName = 'ParabolaIcon';

export default ParabolaIcon;
